import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["border:2px solid #000;border-radius:0;padding:0.5rem;"]);
/**
 * Renders an `input` element with some default styles.
 *
 * @public
 * @author Connor Taylor
 */

var SingleLineInput = makeThemedComponent({
  themeKey: "TextInput",
  component: "input",
  defaultStyles: defaultStyles
});
var MultilineInput = SingleLineInput.withComponent("textarea");

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TextInput, _Component);

  function TextInput() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TextInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        multiline = _this$props.multiline,
        rest = _objectWithoutPropertiesLoose(_this$props, ["multiline"]);

    return this.props.multiline ? React.createElement(MultilineInput, rest) : React.createElement(SingleLineInput, rest);
  };

  return TextInput;
}(Component);

export { defaultStyles };
/** @component */

export default TextInput;